import { render, staticRenderFns } from "./UserFormSpecialisedSectors.vue?vue&type=template&id=fc4ca468"
import script from "./UserFormSpecialisedSectors.vue?vue&type=script&lang=js"
export * from "./UserFormSpecialisedSectors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fc4ca468')) {
      api.createRecord('fc4ca468', component.options)
    } else {
      api.reload('fc4ca468', component.options)
    }
    module.hot.accept("./UserFormSpecialisedSectors.vue?vue&type=template&id=fc4ca468", function () {
      api.rerender('fc4ca468', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/User/Form/UserFormSpecialisedSectors.vue"
export default component.exports